import { useQuery } from '@tanstack/react-query'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { ProjectService } from 'src/services/project.service'

export const useSelfConfigurationFollowup = (followupId: string | undefined) => {
  const { project } = useCurrentProject()

  return useQuery({
    queryKey: ['followup-self-configuration', project.id, followupId],
    queryFn: () => ProjectService.getSelfConfigurationFollowup(project.id, followupId!),
    enabled: !!followupId,
  })
}
